export default __webpack_public_path__ + "static/front-bg-44c74778080658b521e6d8ed8030c5f9.png";